import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getVoices(): Promise<any> {
  return authenticatedInstance.get('/voices');
}
